
export const useMonths = () => {
    const thangs = [

        { id: 1, thang: `Tháng 1`, idx: 7, thang_en: "January" },
        { id: 2, thang: `Tháng 2`, idx: 8, thang_en: "February" },
        { id: 3, thang: `Tháng 3`, idx: 9, thang_en: "March" },
        { id: 4, thang: `Tháng 4`, idx: 10, thang_en: "April" },
        { id: 5, thang: `Tháng 5`, idx: 11, thang_en: "May" },
        { id: 6, thang: `Tháng 6`, idx: 12, thang_en: "June" },
        { id: 7, thang: `Tháng 7`, idx: 1, thang_en: "July" },
        { id: 8, thang: `Tháng 8`, idx: 2, thang_en: "August" },
        { id: 9, thang: `Tháng 9`, idx: 3, thang_en: "September" },
        { id: 10, thang: `Tháng 10`, idx: 4, thang_en: "October" },
        { id: 11, thang: `Tháng 11`, idx: 5, thang_en: "November" },
        { id: 12, thang: `Tháng 12`, idx: 6, thang_en: "December" },

    ]

    return {
        thangs: thangs.sort((a, b) => a.idx - b.idx)
    };
}
